export function submitSearchChatForm() {
    $('#search').keypress(function(e){
        if(e.which == 13){
            $('form[name=search_form]').submit();
        }
    });
}